import { Dispatch } from "react";
import { LoadingFSProps } from "../../../hooks";
import { WebEnum } from "../web.props";
import { random20DarkColors } from "../../../utils";

export const webActions = (dispatch: Dispatch<any>) => {
  const setLoading = (loading: LoadingFSProps) => {
    return dispatch({
      type: WebEnum.LOADING,
      payload: {
        isLoading: loading.isLoading,
        text: loading.text ?? "",
      },
    });
  };

  const setOperationsPerDay = (operationsPerDay: number) => {
    return dispatch({
      type: WebEnum.OPERATIONS_PER_DAY,
      payload: operationsPerDay,
    });
  };

  const createArrayRandom20DarkColors = () => {
    return dispatch({
      type: WebEnum.ARRAY_RANDOM_20_DARK_COLORS,
      payload: random20DarkColors,
    });
  };

  return { setLoading, setOperationsPerDay, createArrayRandom20DarkColors };
};
